import React, { useState } from 'react'
import ButtonModalOpen from '../../elements/ButtonModalOpen'

const ViewServices = ({ services, setIdList, setNameList2, setIdServiceModal }) => {
    const [showList,setShowList] = useState(false)

    return (
        <div>

            {/* BUTTON ADD GROUPE LIST */}
            <ButtonModalOpen
                title='Ajouter un groupe'
                modal='modalList'
            />

            {/* LIST SERVICES */}
            {services.filter(l => l.doc === 'docList').sort((a,b) => a.nameList > b.nameList ? 1 : -1).map(l => (
                <div className="shadow row mt-3" key={l.id}>
                    <div className="card-body">
                        <div className='row' onClick={() => setShowList(showList === l.id ? '' : l.id)}>
                            <div className='col'>
                                {l.nameList}
                            </div>
                            <div className='col text-end'>
                                <i className={showList === l.id ? "bi bi-chevron-compact-up" : "bi bi-chevron-compact-down"}></i>
                            </div>
                        </div>
                        {showList === l.id &&
                        <>
                            <div className='row border-top mt-3 border-end'> 
                                <div className='col text-center border-end mt-3'>
                                    <div className='' data-bs-toggle="modal" style={{ cursor:'pointer' }} data-bs-target="#modalService" onClick={() => [setNameList2(l.nameList)]}>Ajouter un service</div>
                                </div>
                                <div className='col text-center mt-3'>
                                    <div className='' data-bs-toggle="modal" style={{ cursor:'pointer' }} data-bs-target="#modalDeleteList" onClick={() => [setIdList(l.id),setNameList2(l.nameList)]}>Supprimer la liste</div>
                                </div>
                            </div>
                            {services.filter(s => s.nameList === l.nameList && s.doc === 'docService').sort((a,b) => a.nameService > b.nameService ? 1 : -1).map(s => (
                                <div key={s.id}>
                                    <div className='row border-top mt-3 pt-3'>
                                        <div className='col'>
                                            {s.nameService}
                                            <br/>
                                            <span className='text-muted'>{s.durationService}min</span> <span className='text-bold mx-2'>{s.priceService}€</span> 
                                        </div>
                                        <div className='col text-end align-self-center'>
                                            <u onClick={() => setIdServiceModal(s.id)} data-bs-toggle="modal" style={{ cursor:'pointer' }} data-bs-target="#modalDeleteService">supprimer</u>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                        }
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ViewServices


